module.exports = __webpack_public_path__ + "static/media/home5.f0ba6291.jpg";